import { render, staticRenderFns } from "./AirBreathingApparatus.vue?vue&type=template&id=c99d1ba6&scoped=true"
import script from "./AirBreathingApparatus.vue?vue&type=script&lang=js"
export * from "./AirBreathingApparatus.vue?vue&type=script&lang=js"
import style0 from "./AirBreathingApparatus.vue?vue&type=style&index=0&id=c99d1ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99d1ba6",
  null
  
)

export default component.exports